export const SAFEGUARDING_TIERS = [
  {
    key: 'base',
    label: 'Base',
    color: '#D3BDFF',
    description: 'No elevated signs of strain',
  },
  {
    key: 'enhanced_monitoring',
    label: 'Enhanced Monitoring',
    color: '#9E6AFF',
    description: 'Early indicators of financial strain',
  },
  {
    key: 'targeted_feedback',
    label: 'Targeted Feedback',
    color: '#7A50D1',
    description: 'Several strain indicators together',
  },
  {
    key: 'active_support',
    label: 'Active Support',
    color: '#422D75',
    description: 'Sustained or serious strain',
  },
];

export const ADDITIONAL_SUPPORT_TIER_KEYS = ['enhanced_monitoring', 'targeted_feedback', 'active_support'];

const round1 = value => Math.round(value * 10) / 10;

export function mapSafeguardingBreakdown(breakdown) {
  const total = breakdown?.total ?? 0;

  const byKey = {};
  (breakdown?.tiers ?? []).forEach(row => {
    byKey[row.tier] = { count: row.count ?? 0, percent: row.percent ?? 0 };
  });
  const get = key => byKey[key] ?? { count: 0, percent: 0 };

  const base = get('base');
  const supportedCount = ADDITIONAL_SUPPORT_TIER_KEYS.reduce((sum, key) => sum + get(key).count, 0);
  const supportedPercent = round1(ADDITIONAL_SUPPORT_TIER_KEYS.reduce((sum, key) => sum + get(key).percent, 0));
  const active = get('active_support');

  const tiers = SAFEGUARDING_TIERS.map(tier => ({
    ...tier,
    count: get(tier.key).count,
    percent: get(tier.key).percent,
  }));

  return {
    total,
    hasData: total > 0,
    monitored: total,
    basePercent: base.percent,
    supportedCount,
    supportedPercent,
    activeCount: active.count,
    activePercent: active.percent,
    tiers,
  };
}
